import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip, Badge,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next"
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import { LargeModal } from "components/Common/LargeModal"
import { cardsData, getData } from "./data"
import {convertToDateTimeString, hasPermission, numberWithCommas} from "../../../helpers/helpers";
import {deleteJackpot} from "../../../store/jackpots/actions";
import * as moment from "moment";
function Table(props) {
  const [isOpen, setIsOpen] = useState(false)

  const { data } = props
  const columns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "created_at",
      text: "Created Date",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "250px" }
      },
      formatter: (cell, row) => {
        const date = new Date(row?.created_at)
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        })
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, match =>
          match.toUpperCase()
        )
        return <>{capitalizedDate}</>
      },
    },
    {
      text: "Channels",
      sort: true,
      style: { whiteSpace: "break-spaces" },
      formatter: (cellContent, row) => {
        return (
          <>
            {row.channels.map((s, index) => {
              return (
                <Link
                  to="#"
                  className="badge badge-soft-primary font-size-11 m-1"
                  key={"_skill_" + s.id + index}
                >
                  {s.name}
                </Link>
              )
            })}
          </>
        )
      },
    },
    {
      text: "Market",
      dataField: "market",
      sort: true,
    },
    {
      text: "Prizes",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <>
          <p className="mb-1 fw-bold">{numberWithCommas(row.max_price)}</p>
          <p className="mb-0 fw-bold">{numberWithCommas(row.n_1)}</p>
          <p className="mb-0 fw-bold">{numberWithCommas(row.n_2)}</p>
        </>
      ),
    },
    {
      dataField: "price_per_ticket",
      text: "Price",
      sort: true,
      formatter: (cellContent, row) => (
        <>
          <p>{numberWithCommas(row.price_per_ticket)}</p>
        </>
      ),
    },
    {
      dataField: "is_active",
      text: "Active",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => {
        return (
          <>
            {row.is_active ? (
              <Badge color="success" className="bg-success font-size-12">
                <i className="mdi mdi-check-bold" />
              </Badge>
            ) : (
              <Badge color="danger" className="bg-danger font-size-12">
                <i className="mdi mdi-close" />
              </Badge>
            )}
          </>
        )
      },
    },
    {
      dataField: "view",
      isDummyField: true,
      text: "Action",
      sort: true,
      formatter: (cellContent, row) => (
        <>
          <Row>
            <Col lg={3}>
              <Button type="button" color="primary" className="btn-sm">
                Details
              </Button>
            </Col>
          </Row>
        </>
      ),
    },
  ]

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]
  const { SearchBar } = Search
  //pagination customization

  const pageOptions = {
    sizePerPage: 10,
    totalSize: data?.length,
    custom: true,
  }

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      e.preventDefault()

      props.history.push(`${window.location.pathname}/jackpot-bet/${row.id}`)
      // setIsOpen(true)
    },
  }
  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Jackpot Tickets"}</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="6">
                        <Row>
                          <Col sm="6">
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                          <Col sm="6">
                            <div>
                              <ReactHTMLTableToExcel
                                  id="test-table-xls-button"
                                  className="download-table-xls-button w-md btn btn-primary"
                                  table="table-to-xls"
                                  filename={`Jackpot-Report-${moment(new Date()).format("DD/MM/YYYY")}`}

                                  sheet="tablexls"
                                  buttonText="Download"
                                  type="button"
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={6}></Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable id="table-to-xls"
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            //   selectRow={selectRow}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                            rowEvents={rowEvents}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>

    </>
  )
}

export default withRouter(Table)
